import { render, staticRenderFns } from "./AddPhone.vue?vue&type=template&id=4d9a5e65&scoped=true"
import script from "./AddPhone.vue?vue&type=script&lang=js"
export * from "./AddPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a5e65",
  null
  
)

export default component.exports